<div class="ion-header ion-hide-lg-up v">
  <header-main></header-main>
  <div class="ion-fab">
    <div class="ion-fab-button close button-tertiary button-round">
      <a href="/how-it-works">
        <img class="ion-icon" src="assets/icons/close.svg">
      </a>
    </div>
  </div>
</div>

<main class="ion-content" fullscreen>
  <header class="ion-hide-lg-down v">
    <header-desktop></header-desktop>
    <h1 color="white">
      <svg class="ion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.67 44.15"><defs><style>.volunteers{stroke:none;}</style></defs><title>volunteers</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="volunteers" d="M29.86,44.15A14.24,14.24,0,0,1,19.72,40a2,2,0,1,1,2.83-2.83,10.33,10.33,0,0,0,14.62,0L52.64,21.65A10.34,10.34,0,0,0,38.1,7L37,8.34a2,2,0,1,1-3.15-2.46L35,4.38l.16-.18A14.34,14.34,0,0,1,59.67,14.34a14.2,14.2,0,0,1-4.2,10.13L40,40A14.2,14.2,0,0,1,29.86,44.15Z"></path><path class="volunteers" d="M29.81,44.15A14.24,14.24,0,0,1,19.67,40L4.2,24.47A14.33,14.33,0,0,1,4.2,4.2a14.34,14.34,0,0,1,20.28,0L43.11,22.66a2,2,0,0,1-2.82,2.84L21.65,7A10.34,10.34,0,1,0,7,21.65L22.5,37.12a10.33,10.33,0,0,0,14.62,0A2,2,0,0,1,40,40,14.24,14.24,0,0,1,29.81,44.15Z"></path></g></g></svg>
      How it works: Volunteers
    </h1>
  </header>

  <div class="container-fluid details-wrapper">
    <div class="row">
      <div class="col col-xs-12 col-md-10 col-lg-8 col-xl-6 col-md-offset-1 col-lg-offset-2 col-xl-offset-3">
        <div class="details-content">
          <img class="ion-margin-bottom" src="assets/images/how-it-works/volunteers.jpg" alt="Volunteers">
          <div>
            <div class="description"><p>Many of us have thought about giving our time to a worthy initiative, but if you’re not connected to a cause, it can be hard to know where to start. We want to remove the current hurdles associated with finding volunteers or finding opportunities to volunteer.</p>
              
              <p>Our aim is to provide real opportunities for charities and communities to get stuff done, easier and faster.
                
              Volunteering is essentially a free gig. You list a gig, negotiate and agree on tasks. Once it’s completed, simply provide feedback - no payment is exchanged for volunteer gigs.</p>
              
              <p>Each amazing volunteer will be able to build their deserved reputation.</p>
              
              <p>To ensure no one exploits the good nature of those willing to donate their time, we authenticate all volunteer requests.</p>
                
              <p>All volunteering is free to post - get in touch with us if you’d like to list a volunteer request.</p>
              
              <p>For more information see our <a routerLink="/support">Help Centre</a> &amp; <a href="/faqs">FAQs</a>.</p>
              
              <h5>gig exchange - empowering the volunteer win</h5>
            </div>
          </div>
          <div class="details-author">
            <p>Posted by: gigexchange</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-hide-lg-up">
  <footer-main></footer-main>
</footer>
